// Interfaces
import { IOnlineRatingsData } from "./interfaces";

// Components
import { OnlineRatingsLoader } from "../DashboardLoader";
import { RatingList } from "./RatingList";

// MUI
import { Box } from "@mui/material";

// Images
import empty from "@/assets/images/commons/empty.png";

export default function OnlineRatingsData(props: Readonly<IOnlineRatingsData>) {
	const { data = [], isLoading = false } = props;

	if (isLoading) {
		return <OnlineRatingsLoader />;
	}

	if (!data.length) {
		return (
			<Box className="w-[200px] mx-auto min-h-[320px] py-[20px]">
				<img width="100%" src={empty} alt="No data image" />
			</Box>
		);
	}

	return <RatingList data={data} />;
}
